<template lang="pug">
  .profile-page__main
    .profile-page__body
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Контакты
        .profile-section__body
          .form
            .form__elem.form__elem_full
              manager-shift-editor-copy-form-data(
              v-if="otherShifts.length > 0"
              :options="otherShifts"
              :current-data="fields"
              :current-shift="shiftData"
              @update-field="updateField"
              @cancel-update-field="cancelUpdateField"
              )
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title Руководитель программы
                .form-elem__body
                  input.input.input_full(
                  maxlength="50"
                  v-model="fields.fio"
                  )
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title Почта
                .form-elem__body
                  input.input.input_full(
                  maxlength="50"
                  v-model="fields.email"
                  )
            .form__elem
              .form-elem.form-elem_horizontal
                .form-elem__title Телефон
                .form-elem__body
                  input.input.input_full(
                  maxlength="50"
                  v-model="fields.phone"
                  )
      section.profile-page-form__section.profile-section
        .profile-section__body
          .form
            .form__elem.form__elem_button
              .form-elem
                .form-elem__body
                  button.button.button_paint-main.button_long(
                  @click.prevent="onSaveCamp()"
                  )
                    .button__text Сохранить
                .form-elem__error(
                v-if="currentErrorMessage.length > 0"
                ) {{currentErrorMessage}}

</template>

<script>

import ManagerShiftEditorCopyFormData from "./components/ManagerShiftEditorCopyFormData";
export default {
  name: "ManagerShiftEditorContacts",
  components: {ManagerShiftEditorCopyFormData},
  props: {
    currentErrorMessage: {
      type: String,
      default: ""
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    shiftData: {
      type: Object,
      default: () => ({})
    },
    otherShifts: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      fields: {
        fio: "",
        email: "",
        phone: ""
      }
    };
  },
  methods: {
    setFields(data) {
      this.fields.fio = data.contacts.fio;
      this.fields.email = data.contacts.email;
      this.fields.phone = data.contacts.phone;
    },
    onSaveCamp() {
      const data = {
        contacts: {
          fio: this.fields.fio,
          email: this.fields.email,
          phone: this.fields.phone
        }
      };
      this.$emit("on-save-shift", data);
    },
    updateField(data) {
      this.setFields(data);
    },
    cancelUpdateField(data) {
      for (const key in data) {
        this.fields[key] = data[key];
      }
    }
  },
  watch: {
    shiftData(val) {
      this.setFields(val);
    }
  },
  mounted() {
    if (this.shiftData) {
      this.setFields(this.shiftData);
    }
  }
};
</script>
